import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { GridNumber, LottolocaNumber } from '../../models/grid-number.model';
import { Lottery } from '../../lottoloca-commom/lottery-modex';
import { List } from 'linqts';

@Component({
  selector: 'kt-grid-numbers',
  templateUrl: './grid-numbers.component.html',
  styleUrls: ['./grid-numbers.component.scss']
})
export class GridNumbersComponent implements OnInit, OnChanges {


  @Input() public cols: number = 10;
  @Input() public rows: number = 10;
  @Input() public numberList: LottolocaNumber[] = [];
  @Input() public headerNumberList: LottolocaNumber[] = [];
  @Input() public checkedNumbers: string = "";
  @Input() public readOnly = false;
  @Input() public max = 100;

  //public _gridNumbers: GridNumber[] = [];

  settingState: string;
  numberTypeSelected: string = "normal";
  normalCount: any;
  public gridNumbersList: List<GridNumber> = new List<GridNumber>();


  @Output() public numbersSelectedChange: EventEmitter<number[]> = new EventEmitter();


  filterTypes: any[];

  public minDefault: number = 0;

  public maxDefault: number = 0;
  public count: number = 0;
  public maxNumber: number;
  public filterName: string = "";

  _error: string;
  rowHeight: string;

  constructor() { }

  ngOnInit() {

    this.adjusts();
  }

  adjusts() {
    this.rowHeight = "1.5:1";

    if (this.cols < 10 && this.cols > 4) {
      this.rowHeight = "3:1";
    }
    else if (this.cols <= 4) {
      this.rowHeight = "4:1";
    }
  }


  ngOnChanges(changes: SimpleChanges): void {

    this.adjusts();

    this.gridNumbersList.Clear();
    let splited = this.checkedNumbers.trim().split(' ');


    if (this.headerNumberList == null) {
      this.headerNumberList = [];
    }

    for (let i of this.numberList) {
      let gridNumber = new GridNumber();
      gridNumber.value = i.value;
      gridNumber.name = i.name;



      if (splited.some(x => Number(x) == i.value)) {
        gridNumber.state = "selected";
      }
      else {
        gridNumber.state = "unselected";
      }

      gridNumber.numberType = "normal";


      this.gridNumbersList.Add(gridNumber);
  

    }


  }




  public mouseDown(gridNumber: GridNumber, event: MouseEvent): void {


    if (!this.readOnly) {
      if (gridNumber.state == "selected") {
        this.settingState = "unselected";
      }
      else {

        this.settingState = "selected";

      }

      this.mouseOver(gridNumber, event);
    }
  }
  public mouseOver(gridNumber: GridNumber, event: MouseEvent): void {

    if (!this.readOnly) {
      let number = gridNumber;



      if (this.gridNumbersList.Where(x => x.state === "selected" && x.numberType == "normal").Count() >= this.max
        && this.settingState == "selected") {


        return;
      }

      if (event.which == 1) {

        number.state = this.settingState;



        if (number.state == "selected") {
          number.numberType = this.numberTypeSelected;
        }
        else {
          number.numberType = "normal";
        }


        this.normalCount = this.gridNumbersList.Where(x => x.state === "selected" && x.numberType == "normal").Count();

        let selValues = this.gridNumbersList
          .Where(x => x.state === "selected" && x.numberType == "normal")
          .Select(x => x.value)
          .ToArray();

        this.numbersSelectedChange.emit(selValues);


      } else if (event.which == 3) {
        //console.log('mouse down state with right click');
      } else {
        // console.log('mouse update');
      }

    }

  }



}
